$(document).ready(function(){
	$('.header').hide();
	$('.m--header').hide();
	$('.visitform').hide();
	$('.subscribe-connect').hide();
	$('.footer').hide();
	$('.copyright').hide();
    $('.disclaimer').hide();

	accordion();
})

function accordion(){
	$('.toggle').click(function(e) {
		e.preventDefault();

		var $this = $(this);

		if ($this.next().hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
			$this.removeClass('active');
		} else {
			$this.parent().parent().find('li .inner').removeClass('show');
			$this.parent().parent().find('li .toggle').removeClass('active');
			$this.parent().parent().find('li .inner').slideUp(350);
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
			$this.toggleClass('active');
		}
	});
}


var gmapsData = [];
var R = 6371;
var infowindow = null;

var iconBase = '/images/township/marker_icon/';

var icons = {
    township: {
        icon: iconBase + 'logo-paradiseresortblue.png'
    },
    accommodation: {
        icon: iconBase + 'marker-accommodation.png'
    },
    station: {
        icon: iconBase + 'marker-station.png'
    },
    shop: {
        icon: iconBase + 'marker-shop.png'
    },
    school: {
        icon: iconBase + 'School.png'
    },
    hotel: {
        icon: iconBase + 'marker-hotel.png'
    },
    hospital: {
        icon: iconBase + 'marker-hospital.png'
    },
    highway: {
        icon: iconBase + 'marker-highway.png'
    },
    mall: {
        icon: iconBase + 'marker-shop.png'
    }    ,
    university: {
        icon: iconBase + 'University.png'
    },
    supermarket: {
        icon: iconBase + 'Supermarket.png'
    },
    traditional_market: {
        icon: iconBase + 'Traditional_Market.png'
    }
};

var mapsData = [[0,"GLOBAL ISLAMIC SCHOOL",-6.344806,106.6905,"school","/bin/db/images/township/paradise-serpong-city/maps/s1.png"],[1,"SMP AL AZHAR",-6.348543,106.697293,"school","/bin/db/images/township/paradise-serpong-city/maps/s5.png"],[2,"CATHOLIC SCHOOL MATER DEI PAMULANG",-6.346042,106.730067,"school","/bin/db/images/township/paradise-serpong-city/maps/s28.png"],[3,"STELLA MARRIS",-6.314923,106.686002,"school","/bin/db/images/township/paradise-serpong-city/maps/stella marris.jpg"],[4,"SAINT JOHN CATHOLIC SCHOOL",-6.314826,106.682632,"school","/bin/db/images/township/paradise-serpong-city/maps/SAINT JOHN CATHOLIC SCHOOL.jpg"],[5,"SANTA URSULA",-6.30171,106.683293,"school","/bin/db/images/township/paradise-serpong-city/maps/SANTA URSULA.jpg"],[6,"JAPAN INTERNATIONAL SCHOOL BINTARO",-6.284476,106.699172,"school","/bin/db/images/township/paradise-serpong-city/maps/JAPAN INTERNATIONAL SCHOOL BINTARO.jpg"],[7,"SDN PEMBANGUNAN JAYA SCHOOL BINTARO",-6.267518,106.737014,"school","/bin/db/images/township/paradise-serpong-city/maps/SDN PEMBANGUNAN JAYA SCHOOL BINTARO.jpg"],[8,"GLOBAL JAYA SCHOOL",-6.28034,106.699795,"school","/bin/db/images/township/paradise-serpong-city/maps/GLOBAL JAYA SCHOOL.jpg"],[9,"BRITISH INTERNATIONAL SCHOOL BINTARO",-6.272093,106.703404,"school","/bin/db/images/township/paradise-serpong-city/maps/BRITISH INTERNATIONAL SCHOOL BINTARO.jpg"],[10,"BPK PENABUR",-6.272967,106.715306,"school","/bin/db/images/township/paradise-serpong-city/maps/BPK PENABUR.jpg"],[11,"HIGHSCOOP INTERNATIONAL SCHOOL BINTARO",-6.280713,106.695881,"school","/bin/db/images/township/paradise-serpong-city/maps/HIGHSCOOP INTERNATIONAL SCHOOL BINTARO.jpg"],[12,"SDN PEMBANGUNAN JAYA SCHOOL",-6.268211,106.739549,"school","/bin/db/images/township/paradise-serpong-city/maps/SDN PEMBANGUNAN JAYA SCHOOL.jpg"],[13,"AL-AZHAR ISLAMIC SCHOOL",-6.264456,106.742467,"school","/bin/db/images/township/paradise-serpong-city/maps/AL-AZHAR ISLAMIC SCHOOL.jpg"],[14,"RAFFLES CHRISTIAN INTERNATIONAL SCHOOL",-6.195557,106.756302,"school","/bin/db/images/township/paradise-serpong-city/maps/RAFFLES CHRISTIAN INTERNATIONAL SCHOOL.jpg"],[15,"JAKARTA INTERNATIONAL SCHOOL JAKARTA SELATAN",-6.282681,106.787973,"school","/bin/db/images/township/paradise-serpong-city/maps/JAKARTA INTERNATIONAL SCHOOL JAKARTA SELATAN.jpg"],[16,"DON BOSCO SCHOOL",-6.286001,106.785947,"school","/bin/db/images/township/paradise-serpong-city/maps/DON BOSCO SCHOOL.jpg"],[17,"HIGHSCOOP INTERNATIONAL SCHOOL SIMATUPANG",-6.287535,106.804143,"school","/bin/db/images/township/paradise-serpong-city/maps/HIGHSCOOP INTERNATIONAL SCHOOL SIMATUPANG.jpg"],[18,"RSIA HERMINA",-6.169227,106.626655,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RSIA HERMINA.jpg"],[19,"RS PERMATA PAMULANG",-6.343826,106.719043,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS PERMATA PAMULANG.png"],[20,"RS BUAH HATI PAMULANG",-6.343887,106.720798,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS BUAH HATI PAMULANG.jpg"],[21,"RSUD KOTA TANGSEL",-6.33728,106.738616,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RSUD KOTA TANGSEL.jpg"],[22,"RS SARI ASIH",-6.325002,106.744612,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS SARI ASIH.jpg"],[23,"RSIA BUAH HATI CIPUTAT",-6.312432,106.732778,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RSIA BUAH HATI CIPUTAT.jpg"],[24,"RS PREMIERE INTERNATIONAL BINTARO",-6.275853,106.723934,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS PREMIERE INTERNATIONAL BINTARO.jpg"],[25,"EKA HOSPITAL BSD",-6.298689,106.66963,"hospital","/bin/db/images/township/paradise-serpong-city/maps/EKA HOSPITAL BSD.jpg"],[26,"RS PONDOK INDAH",6.283877,106.781669,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS PONDOK INDAH.jpg"],[27,"RS SILOAM SIMATUPANG",-6.292203,106.784361,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS SILOAM SIMATUPANG.jpg"],[28,"RS FATMAWATI",-6.298598,106.794702,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS FATMAWATI.jpg"],[29,"RS BETHSAIDA HOSPITAL",-6.254761,106.622563,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS BETHSAIDA HOSPITAL.jpg"],[30,"RS ST CAROLUS HOSPITAL SUMMARECON",-6.247124,106.642446,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS ST CAROLUS HOSPITAL SUMMARECON.jpg"],[31,"RS OMNI INTERNATIONMAL ALAM SUTERA",-6.24429,106.653318,"hospital","/bin/db/images/township/paradise-serpong-city/maps/RS OMNI INTERNATIONMAL ALAM SUTERA.jpg"],[32,"AEON MALL BSD CITY",-6.304725,106.643729,"mall","/bin/db/images/township/paradise-serpong-city/maps/AEON MALL BSD CITY.jpg"],[33,"TERAS KOTA BSD CITY",-6.2956,106.667445,"mall","/bin/db/images/township/paradise-serpong-city/maps/TERAS KOTA BSD CITY.jpg"],[34,"LIVING WORLD ALAM SUTERA",-6.24441,106.653549,"mall","/bin/db/images/township/paradise-serpong-city/maps/LIVING WORLD ALAM SUTERA.jpg"],[35,"ALAM SUTERA MALL",-6.222769,106.653905,"mall","/bin/db/images/township/paradise-serpong-city/maps/ALAM SUTERA MALL.jpg"],[36,"SUMMARECON MALL SERPONG",-6.241102,106.628211,"mall","/bin/db/images/township/paradise-serpong-city/maps/SUMMARECON MALL SERPONG.jpg"],[37,"KARAWACI SUPERMALL LIPPO",-6.226787,106.607119,"mall","/bin/db/images/township/paradise-serpong-city/maps/KARAWACI SUPERMALL LIPPO.jpg"],[38,"BINTARO X CHANGE MALL",-6.285383,106.727733,"mall","/bin/db/images/township/paradise-serpong-city/maps/BINTARO X CHANGE MALL.jpg"],[39,"PONDOK INDAH MALL",-6.26561,106.783086,"mall","/bin/db/images/township/paradise-serpong-city/maps/PONDOK INDAH MALL.jpeg"],[40,"PAMULANG SQUARE MALL",-6.342866,106.725564,"mall","/bin/db/images/township/paradise-serpong-city/maps/PAMULANG SQUARE MALL.jpg"],[41,"UNIVERSITAS PAMULANG",-6.343452,106.737065,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIVERSITAS PAMULANG.jpg"],[42,"UNIVERSITAS PAMULANG",-6.346185,106.691131,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIVERSITAS PAMULANG 2.jpg"],[43,"INSTITUT TEKNOLOGI INDONESIA",-6.344445,106.675933,"university","/bin/db/images/township/paradise-serpong-city/maps/INSTITUT TEKNOLOGI INDONESIA.jpg"],[44,"UNIVERSITAS PRASETYAMULYA",-6.296148,106.639712,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIVERSITAS PRASETYAMULYA.jpg"],[45,"SINARMAS ACADEMY BSD",-6.301571,106.662403,"university","/bin/db/images/township/paradise-serpong-city/maps/SINARMAS ACADEMY BSD.jpg"],[46,"SWISS-GERMAN UNIVERSITY",-6.224884,106.655098,"university","/bin/db/images/township/paradise-serpong-city/maps/SWISS-GERMAN UNIVERSITY.jpg"],[47,"UNIVERSITAS MULTIMEDIA NUSANTARA",-6.256816,106.617848,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIVERSITAS MULTIMEDIA NUSANTARA.jpg"],[48,"BINUS ALAM SUTERA",-6.223368,106.649236,"university","/bin/db/images/township/paradise-serpong-city/maps/BINUS ALAM SUTERA.jpg"],[49,"UNIVERSITAS PELITA HARAPAN",-6.228081,106.611587,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIVERSITAS PELITA HARAPAN.jpg"],[50,"PEMBANGUNAN JAYA UNIVERSITY BINTARO",-6.292369,106.725451,"university","/bin/db/images/township/paradise-serpong-city/maps/PEMBANGUNAN JAYA UNIVERSITY BINTARO.jpg"],[51,"UNIV. ISLAM NEGERI",-6.306677,106.756162,"university","/bin/db/images/township/paradise-serpong-city/maps/UNIV ISLAM NEGERI.jpg"],[52,"SANTIKA HOTEL TERAS KOTA",-6.295698,106.668416,"hotel","/bin/db/images/township/paradise-serpong-city/maps/SANTIKA HOTEL TERAS KOTA.jpg"],[53,"MERCURE HOTEL ALAM SUTERA",-6.244555,106.652027,"hotel","/bin/db/images/township/paradise-serpong-city/maps/MERCURE HOTEL ALAM SUTERA.jpg"],[54,"IBIS HOTEL GADING SERPONG",-6.247919,106.626655,"hotel","/bin/db/images/township/paradise-serpong-city/maps/IBIS HOTEL GADING SERPONG.jpg"],[55,"SANTIKA HOTEL BINTARO",-6.277086,106.721084,"hotel","/bin/db/images/township/paradise-serpong-city/maps/SANTIKA HOTEL BINTARO.jpg"],[56,"PASAR MODERN PSC SERPONG",-6.304631,106.684692,"traditional_market","/bin/db/images/township/paradise-serpong-city/maps/PASAR MODERN BSD.jpg"],[57,"PASAR MODERN PASAR KITA PAMULANG KOTA",-6.340745,106.737494,"traditional_market","/bin/db/images/township/paradise-serpong-city/maps/PASAR MODERN PASAR KITA PAMULANG KOTA.jpg"],[58,"PASAR MODERN BINTARO",-6.279986,106.718934,"traditional_market","/bin/db/images/township/paradise-serpong-city/maps/PASAR MODERN BINTARO.jpg"],[59,"PASAR MODERN BSD",-6.304429,106.684816,"traditional_market","/bin/db/images/township/paradise-serpong-city/maps/PASAR MODERN BSD.jpg"],[60,"SUPERINDO PONDOK BENDA",-6.338254,106.708715,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/SUPERINDO PONDOK BENDA.jpg"],[61,"CARREFOUR PAMULANG",-6.342776,106.725112,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/CARREFOUR PAMULANG.jpg"],[62,"GIANT PAMULANG",-6.342435,106.725072,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/GIANT PAMULANG.jpg"],[63,"TIPTOP CIPUTAT",-6.33209,106.749328,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/TIPTOP CIPUTAT.jpg"],[64,"CARREFOUR CIPUTAT",-6.321296,106.747438,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/CARREFOUR CIPUTAT.jpg"],[65,"LOTTE MART CIPUTAT",-6.303789,106.756577,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/LOTTE MART CIPUTAT.jpg"],[66,"CARREFOUR LEBAK BULUS",-6.287675,106.775876,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/CARREFOUR LEBAK BULUS.jpg"],[67,"GIANT LEBAK BULUS",-6.290437,106.778193,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/GIANT LEBAK BULUS.jpg"],[68,"CARREFOUR BINTARO",-6.275853,106.71906,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/CARREFOUR BINTARO.jpg"],[69,"GIANT BINTARO",-6.275774,106.719228,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/GIANT BINTARO.jpg"],[70,"LOTTE MART BINTARO",-6.27503,106.723573,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/LOTTE MART BINTARO.jpg"],[71,"GIANT BSD",-6.298304,106.666261,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/GIANT BSD.jpg"],[72,"CARREFOUR BSD",-6.286295,106.664693,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/CARREFOUR BSD.jpg"],[73,"ITC BSD",-6.286095,106.664131,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/ITC BSD.jpg"],[74,"GIANT ALAM SUTERA",-6.238586,106.660578,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/GIANT ALAM SUTERA.jpg"],[75,"IKEA ALAM SUTERA",-6.219762,106.663161,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/IKEA ALAM SUTERA.jpg"],[76,"HYPERMART SUMMARECON",-6.244137,106.629624,"supermarket","/bin/db/images/township/paradise-serpong-city/maps/HYPERMART SUMMARECON.jpg"]];
var MainName = 'Paradise Serpong City';
var MainIcon = 'http://devprogressgroup.qeon.co.id/bin/db/images/township/Logo-paradiseserpongcity.png';
var MainLatitude = -6.352418;
var MainLongtitude = 106.695599;
var LatitudeView = -6.3068149;
var LongtitudeView = 106.7105653;

/**
 * Function to init map
 */

function initMap() {

    var center = new google.maps.LatLng(LatitudeView, LongtitudeView);

    var myStyles =[
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                { visibility: "off" }
            ]
        }
    ];

    var mapOptions = {
        zoom: 13,
        center: center,
        mapTypeId: 'roadmap',
        scrollwheel: false,
        styles: myStyles
    };

    var Township = [
        ['0', MainName, MainLatitude, MainLongtitude, 'township', MainIcon]
    ]

    map = new google.maps.Map(document.getElementById('map'), mapOptions);

    addMarker(Township[0]);

    for (i = 0; i < mapsData.length; i++) {
        addMarker(mapsData[i]);
    }
}

/**
 * Function to add marker to map
 */
function addMarker(marker) {
    var imageInfo   = marker[5];
    var category    = marker[4];
    var placeInfo   = marker[1];
    var pos         = new google.maps.LatLng(marker[2], marker[3]);
    var content     = marker[1];

    if (typeof(Number.prototype.toRad) === "undefined") {
        Number.prototype.toRad = function() {
            return this * Math.PI / 100;
        }
    }

    marker1 = new google.maps.Marker({
        placeInfo: placeInfo,
        position: pos,
        category: category,
        map: map,
        imagesInfo: imageInfo,
        lat1rad : MainLatitude.toRad() ,
        lat2rad  : marker[2].toRad() ,
        tatac :  (marker[2]-MainLatitude).toRad(),
        lontac : (marker[3]-MainLongtitude).toRad(),
        icon : icons[marker[4]].icon,
    });

    gmapsData.push(marker1);

    if (infowindow) {
        infowindow.close();
    }

    infowindow = new google.maps.InfoWindow({
        content: ''
    });

    // Marker click listener
    if(marker[4] !== 'township') {

        google.maps.event.addListener(marker1, 'click', (function (marker1, content) {

            if(marker1.category != 'cluster') {
                var a = Math.sin(marker1.tatac/2) * Math.sin(marker1.tatac/2) + Math.cos(marker1.lat1rad) * Math.cos(marker1.lat2rad) * Math.sin(marker1.lontac/2) * Math.sin(marker1.lontac/2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var d = R * c;
            }

            var contentString = '<div class="box__info">' +
                '<div class="row">' +
                '<div class="span2 gotham bold marginr0 box__info-distance">'+Math.round(d)+'<br><span class="gotham book">KM</span></div>' +
                '<div class="span10">' +
                '<h5 class="margin0 gotham book">'+marker1.placeInfo+'</h5>' +
                '<small class="gotham bold s10">'+marker1.category+'</small>' +
                '</div>' +
                '</div>' +
                '<center><img src="'+marker1.imagesInfo+'" alt=""></center>' +
                '</div>';

            return function () {
                infowindow.setContent(contentString);
                infowindow.open(map, marker1);
            }
        })(marker1, content));

    }

    /**
     * remove default infowindow
     */
    google.maps.event.addListener(infowindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        // Remove the background shadow DIV
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        // Remove the white background DIV
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        iwOuter.parent().parent().css({left: '0px'});

        // Apply the desired effect to the close button
        var iwCloseBtn = iwOuter.next();
        iwCloseBtn.addClass('box__info__close');

    });
}

$('.fullmap--link').on('click', function () {
  google.maps.event.trigger(gmapsData[$(this).data('markerid')], 'click');
});